const DEFAULT_SHADER = 'Mandelbrot';

export default {
  DEFAULT_SHADER
};
